"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyDetailsValidationSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("../enums");
const Features = zod_1.z.object({
    id: zod_1.z.string(),
    ENG: zod_1.z.string(),
    DEU: zod_1.z.string(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.PropertyDetailsValidationSchema = zod_1.z
    .object({
    numberOfRooms: zod_1.z.number(),
    size: zod_1.z.number(),
    buildingYear: zod_1.z.string(),
    buildingCondition: zod_1.z.nativeEnum(enums_1.TBuildingCondition),
    propertyType: zod_1.z.nativeEnum(enums_1.TPropertyType),
    heatingType: zod_1.z.nativeEnum(enums_1.THeatingType),
    carbonEmission: zod_1.z.number(),
    energyEmission: zod_1.z.number().min(0),
    features: zod_1.z.array(Features).max(6),
    constructionStatus: zod_1.z.nativeEnum(enums_1.TConstructionStatus),
    powerOutput: zod_1.z.number().nullable(),
    powerOutputPerAnno: zod_1.z.number().nullable(),
    lifespan: zod_1.z.number(),
    commissioningDate: zod_1.z.coerce.date(),
    constructionType: zod_1.z.enum(enums_1.PowerPlantConstructionTypes),
    propertySecurity: zod_1.z.string(),
    powerplantType: zod_1.z.enum(enums_1.PowerPlantPropertyTypes),
    expectedBuildingStartDate: zod_1.z.coerce.date().nullable().default(null),
    highlights: zod_1.z.array(zod_1.z.string().max(100)),
    storage: zod_1.z.string(),
    storageSize: zod_1.z.string(),
})
    .partial();
//# sourceMappingURL=propertyDetails.js.map